/**
 * @generated SignedSource<<319634648918c04339b3aa3b067249cb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FreelancerProfile_UserScene$data = {
  readonly id: string;
  readonly self: boolean | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"FreelancerProfileHead_User" | "FreelancerProfile_User">;
  readonly " $fragmentType": "FreelancerProfile_UserScene";
};
export type FreelancerProfile_UserScene$key = {
  readonly " $data"?: FreelancerProfile_UserScene$data;
  readonly " $fragmentSpreads": FragmentRefs<"FreelancerProfile_UserScene">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FreelancerProfile_UserScene",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "self",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FreelancerProfileHead_User"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FreelancerProfile_User"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "d0b916811d0aad0ca8684cf8f4f3183c";

export default node;
